exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-title[data-v-f5c55388],\n.image-wrapper[data-v-f5c55388] {\n  text-align: center;\n}\n.container[data-v-f5c55388] {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #f9f9f9;\n}\n.main[data-v-f5c55388] {\n  margin-top: 66px;\n  display: flex;\n}\n.left[data-v-f5c55388] {\n  flex: 1;\n}\n.middle[data-v-f5c55388] {\n  flex: 1;\n}\n.right[data-v-f5c55388] {\n  flex: 1;\n}\n", ""]);

// exports
